import { useEffect, useState, useRef } from "react";
import "../styles/Apppromopopup.css"

export default function AppPromoPopup({ onClose, delay = 2800, forceOpen = false }) {
    const [visible, setVisible] = useState(false);
    const [closing, setClosing] = useState(false);
    const [claimed, setClaimed] = useState(false);
    const [scanPos, setScanPos] = useState(0);

    // Auto-show on true page load — once per session
    // useEffect(() => {
    //     const navEntry = performance.getEntriesByType("navigation")[0];
    //     const navType = navEntry?.type;
    //     const isAllowed = navType === "reload" || navType === "navigate";
    //     const alreadyShown = sessionStorage.getItem("vkp-popup-shown");
    //     if (!isAllowed || alreadyShown) return;
    //     const t = setTimeout(() => {
    //         setVisible(true);
    //         sessionStorage.setItem("vkp-popup-shown", "1");
    //     }, delay);
    //     return () => clearTimeout(t);
    // }, [delay]);

    // forceOpen — triggered by Download app button click
    useEffect(() => {
        if (forceOpen) {
            setClaimed(false);
            setClosing(false);
            setVisible(true);
        }
    }, [forceOpen]);

    // Scanline sweep animation
    useEffect(() => {
        if (!visible) return;
        let frame;
        let pos = -10;
        const sweep = () => {
            pos += 0.35;
            if (pos > 110) pos = -10;
            setScanPos(pos);
            frame = requestAnimationFrame(sweep);
        };
        frame = requestAnimationFrame(sweep);
        return () => cancelAnimationFrame(frame);
    }, [visible]);

    function dismiss() {
        setClosing(true);
        setTimeout(() => {
            setVisible(false);
            setClosing(false);
            onClose?.();
        }, 420);
    }

    function handleClaim() {
        setClaimed(true);
    }

    if (!visible) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className={`vkp-backdrop ${closing ? "vkp-backdrop--out" : "vkp-backdrop--in"}`}
                onClick={dismiss}
            />

            {/* Popup */}
            <div
                className={`vkp-popup ${closing ? "vkp-popup--out" : "vkp-popup--in"}`}
                role="dialog"
                aria-modal="true"
                aria-label="Download Vegas Karts App"
            >
                {/* Scan sweep */}
                <div
                    className="vkp-scan"
                    style={{ top: `${scanPos}%` }}
                />

                {/* HUD corners */}
                <span className="vkp-corner vkp-corner--tl" />
                <span className="vkp-corner vkp-corner--tr" />
                <span className="vkp-corner vkp-corner--bl" />
                <span className="vkp-corner vkp-corner--br" />

                {/* Close */}
                <button className="vkp-close" onClick={dismiss} aria-label="Close">
                    <span>✕</span>
                </button>

                {/* Header bar */}
                <div className="vkp-header-bar">
                    <span className="vkp-header-dot" />
                    <span className="vkp-header-tag">DRIVER PERK // LIMITED OFFER</span>
                </div>

                {/* App icon + title */}
                <div className="vkp-brand">
                    <div className="vkp-app-icon">
                        <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="vkp-icon-svg">
                            <rect width="56" height="56" rx="12" fill="#0d0e1c" />
                            <rect x="1" y="1" width="54" height="54" rx="11" stroke="rgba(255,56,0,0.5)" strokeWidth="1.5" />
                            <path d="M10 36 L16 26 L40 26 L46 36 Z" fill="none" stroke="#FF3800" strokeWidth="1.5" strokeLinejoin="round" />
                            <circle cx="17" cy="37" r="4" fill="none" stroke="#FF3800" strokeWidth="1.5" />
                            <circle cx="39" cy="37" r="4" fill="none" stroke="#FF3800" strokeWidth="1.5" />
                            <path d="M24 26 L26 20 L32 20 L34 26" fill="none" stroke="#00D4FF" strokeWidth="1.2" />
                            <path d="M10 36 L46 36" stroke="#FF3800" strokeWidth="1" opacity="0.4" />
                            <path d="M8 22 L18 22" stroke="#FF3800" strokeWidth="1" opacity="0.5" strokeLinecap="round" />
                            <path d="M6 25 L14 25" stroke="#FF3800" strokeWidth="0.8" opacity="0.3" strokeLinecap="round" />
                        </svg>
                        <div className="vkp-icon-glow" />
                    </div>

                    <div className="vkp-title-block">
                        <h2 className="vkp-title">GET THE APP</h2>
                        <p className="vkp-subtitle">VEGAS KARTS COMMAND CENTER</p>
                    </div>
                </div>

                {/* Divider */}
                <div className="vkp-divider">
                    <span className="vkp-divider-line" />
                    <span className="vkp-divider-text">FREE OFFER INSIDE</span>
                    <span className="vkp-divider-line" />
                </div>

                {/* Shirt offer card */}
                <div className="vkp-offer-card">
                    <div className="vkp-offer-badge">FREE</div>
                    <div className="vkp-offer-body">
                        <div className="vkp-offer-icon">
                            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="28" height="28">
                                <path d="M4 8 L10 4 L13 8 Q16 11 19 8 L22 4 L28 8 L25 14 L22 12 L22 28 L10 28 L10 12 L7 14 Z"
                                    fill="none" stroke="#00D4FF" strokeWidth="1.4" strokeLinejoin="round" />
                                <path d="M13 8 Q16 11 19 8" stroke="#00D4FF" strokeWidth="1.4" />
                            </svg>
                        </div>
                        <div className="vkp-offer-text">
                            <span className="vkp-offer-label">EXCLUSIVE DRIVER SHIRT</span>
                            <span className="vkp-offer-desc">Download app · Book tour · Claim at track</span>
                        </div>
                        <div className="vkp-offer-tag">$35 VALUE</div>
                    </div>
                    <div className="vkp-offer-scan" />
                </div>

                {/* Feature pills */}
                <div className="vkp-features">
                    {[
                        { icon: "◈", label: "Live lap times" },
                        { icon: "◉", label: "Tour booking" },
                        { icon: "⬡", label: "Driver profile" },
                        { icon: "◎", label: "Leaderboard" },
                    ].map(({ icon, label }) => (
                        <div className="vkp-feature" key={label}>
                            <span className="vkp-feature-icon">{icon}</span>
                            <span className="vkp-feature-label">{label}</span>
                        </div>
                    ))}
                </div>

                {/* CTAs */}
                {!claimed ? (
                    <div className="vkp-ctas">
                        <button className="vkp-btn-primary" onClick={handleClaim}>
                            <span className="vkp-btn-glyph">▶</span>
                            CLAIM FREE SHIRT + DOWNLOAD
                        </button>
                        <div className="vkp-store-row">
                            <a href="#" className="vkp-store-btn" aria-label="App Store">
                                <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                                    <path d="M11.5 2.5C12.3 1.5 13.5 1 14.5 1c.1 1.2-.3 2.3-1 3.1-.7.8-1.8 1.4-2.9 1.3-.1-1.1.4-2.2 1.1-3zM14 7c1.7 0 3 .9 3.8 2.2C16 10.3 15 12 15 14c0 2 1 3.8 2 5-.8.6-1.8 1-3 1-1 0-1.7-.5-2.5-.5s-1.6.5-2.6.5C7.5 20 5 17 5 13.5 5 9.5 7.5 7 10 7c1 0 1.8.5 2.5.5S13 7 14 7z" />
                                </svg>
                                App Store
                            </a>
                            <span className="vkp-store-sep">//</span>
                            <a href="#" className="vkp-store-btn" aria-label="Google Play">
                                <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                                    <path d="M3 2.5L11 10l-8 7.5V2.5zM4.5 1.5l9 5-2.3 2.3L4.5 1.5zM4.5 18.5l7-7.3L14 13.5l-9.5 5zM17 10l-2 1.1L13 10l2-1.1L17 10z" />
                                </svg>
                                Google Play
                            </a>
                        </div>
                    </div>
                ) : (
                    <div className="vkp-claimed">
                        <div className="vkp-claimed-icon">✓</div>
                        <div className="vkp-claimed-text">
                            <span className="vkp-claimed-title">CODE SENT TO YOUR DEVICE</span>
                            <span className="vkp-claimed-sub">Present at check-in to redeem your shirt</span>
                        </div>
                    </div>
                )}

                {/* Footer */}
                <p className="vkp-footer-note">
                    One shirt per new driver account · While supplies last · Winter 2026
                </p>
            </div>
        </>
    );
}